import { Grid, Typography } from "@mui/material";
import GameSystemPicker from "../../../../../components/utilities/gamesystempickers/GameSystemPicker";
import GenericPicker from "../../../../../components/utilities/GenericPicker";
import { getEnvironmentVariable } from "../../../../../global/environmentVariables";

const COMPANY_FLAG = getEnvironmentVariable("COMPANY_FLAG");
const SINGLE_GAME_SYSTEM = getEnvironmentVariable("SINGLE_GAME_SYSTEM");

export default function EventCreationGameSystem({
  gameSystem,
  gameSystems,
  setGameSystem,
  setEventValues,
  globalVars,
  eventSubType,
  setEventSubType,
  authContext,
  gameStore,
  setTemplates,
}) {
  return (
    <Grid container spacing={1}>
      {!SINGLE_GAME_SYSTEM && (
        <>
          <Grid item xs={12}>
            <GameSystemPicker
              name="gameType"
              value={gameSystem?.code || ""}
              handleChange={(e) => {
                if (e.target.value !== undefined) {
                  gameSystems.forEach((gs) => {
                    if (gs.code === e.target.value) {
                      setTemplates(null);
                      setGameSystem(gs);
                      if (e.target.value !== gameSystem?.code) {
                        setEventValues(null);
                      }
                      return true;
                    }
                  });
                }
              }}
              gameSystems={gameSystems}
              mode="list"
              request
              eventCreation
            />
          </Grid>
        </>
      )}
      {globalVars?.eventSubTypes?.list?.length > 0 && (
        <>
          <Grid item xs={12}>
            <Typography variant="h4">
              Please Select an{" "}
              {globalVars?.eventSubTypes?.label || "Event Sub Type"}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <GenericPicker
              name="eventSubType"
              label={globalVars?.eventSubTypes?.label || "Event Sub Type"}
              value={eventSubType}
              handleChange={(e) => {
                setEventSubType(e.target.value);
              }}
              list={
                globalVars.eventSubTypes.list.filter((subType) => {
                  
                  if (COMPANY_FLAG === "solforge") {
                    if (authContext?.authState?.identity?.isAdmin) {
                      return true;
                    }
                    return subType === "Bronze" || subType === "Casual";
                  }
                  return true;
                }) || []
              }
              inclAny={false}
            />
          </Grid>
        </>
      )}
    </Grid>
  );
}
